import { FunctionComponent } from 'react';
import PageSidebar from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';
import { DiscountsComponent } from 'components/Discounts/DiscountsComponent';

interface ServicesProps {
    create: string;
}

export const Discounts: FunctionComponent<ServicesProps> = props => {
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('boarding');

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    return (
        <PrivatePage
            title="Automatic Discounts - Cuddles"
            pageName="/discounts"
            pageSidebar={sidebar}
        >
            <DiscountsComponent />
        </PrivatePage>
    );
};

export default Discounts;
